import { styled } from '@mui/material/styles';
import { Button } from 'gatsby-theme-material-ui';

// sizeSmall: {
//  padding: theme.spacing(1, 3),
//  fontSize: theme.typography.pxToRem(13),
// },
// sizeLarge: {
//  padding: theme.spacing(1.5, 4),
//  fontSize: theme.typography.pxToRem(16),
// },

export default styled(Button)(({ theme }) => ({
  borderRadius: 23,
  height: '46px',
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightMedium,
  // TODO: setup theme spacing theme.spacing(2, 4)
  padding: '0 32px',
  boxShadow: 'none',
  whiteSpace: 'nowrap',
  '&:active, &:focus, &:hover': {
    boxShadow: 'none',
  },
}));
